(function () {
  'use strict';
  if (customElements.get('eu-legal-guarantee')) return;

  customElements.define('eu-legal-guarantee', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      var dialog = this.querySelector('dialog');
      var trigger = this.querySelector('[data-guarantee-open]');
      var close = this.querySelector('[data-guarantee-close]');
      if (!dialog || !trigger || !close || typeof dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      var options = { signal: this.controller.signal };
      var layer = window.DrhOverlayManager ? window.DrhOverlayManager.create({
        root: dialog, panel: dialog, native: true, modal: true,
        fallbackFocus: function () { return trigger; }
      }) : null;
      this.layer = layer;
      var pageScrollY = 0;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (dialog.open) return;
        pageScrollY = window.scrollY;
        // Save and lock the page position before native autofocus can scroll it.
        if (layer) layer.open({ trigger: trigger });
        dialog.showModal();
      }, options);
      close.addEventListener('click', function () { dialog.close(); }, options);
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', function () {
        if (layer) {
          layer.close();
          if (!document.body.classList.contains('no-scroll')) {
            window.scrollTo({ top: pageScrollY, left: window.scrollX, behavior: 'instant' });
          }
        }
        else if (trigger.isConnected) trigger.focus({ preventScroll: true });
      }, options);
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.layer) this.layer.destroy();
      this.controller = null;
      this.layer = null;
    }
  });
})();
